<template>
    <div :class="[{'py-3 px-0': $vuetify.breakpoint.xsOnly}, {'pa-5': $vuetify.breakpoint.smAndUp}]">
        <v-row no-gutters>
            <v-col class="grow pl-3 text-h5 font-weight-bold">
                LIVE
                <div v-if="!isLoading" class="font-weight-bold mb-4 blue--text" style="width: 110px">
                    <div class="subtitle-1 my-0 font-weight-medium">Jetzt live ...</div>
                    <v-progress-linear rounded indeterminate color="blue">
                    </v-progress-linear>
                </div>
            </v-col>
            <v-col class="shrink">
                <v-btn color="blue" dark class="mr-1 my-0" @click="reloadSpiele()">
                    <v-icon class="mr-2">mdi-refresh</v-icon>aktualisieren
                </v-btn>
            </v-col>
        </v-row>
        <div v-if="isLoading" class="px-3 mt-3 blue--text">
            <p>Die Live-Spiele werden geladen!</p>
            <div><v-progress-linear indeterminate color="blue"></v-progress-linear></div>
        </div>
        <div v-else-if="gameCount>0" v-for="(lv, i) in lvGroups" :key="i">
            <div v-if="lv.spiele.length > 0 || lv.spieleCup.length > 0">
                <v-card-title :class="[{'pt-3': $vuetify.breakpoint.smAndDown},
                               {'pt-5': $vuetify.breakpoint.mdAndUp}, 'px-3']">
                    {{lv.nameShort}} {{sportJahr.replace('_', '/')}}</v-card-title>
                <spiele :saisonen="lv.saisonen" :live-games="lv.spiele" :live-games-cup="lv.spieleCup"
                        :sport-jahr="sportJahr" :lv-id="lv.nameShort.trim()"
                        :live-only="true">
                </spiele>
            </div>
        </div>
        <div v-else class="px-3">
            Aktuell gibt es keine Live Spiele!
        </div>
        <v-btn fab dark bottom right
               color="primary" style="position: fixed; right: 15px; bottom: 15px; z-index: 15" @click="back()">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
    </div>
</template>

<script>

    import {db} from "../../services/db";
    import {Saison} from "../../services/data/saison";
    import Spiele from "./spiele";
    export default {
        components: {Spiele},
        name: "live-spiele",
        computed: {
            lvLocal(){ return this.$store.state.local.landesverbaende.filter(lv => lv.sportart === 'classic')}
        },
        data: () => ({
            landesverbaende: null,
            gameCount: 0,
            sportJahr: null,
            ligen: null,
            isLoading: false,
            lvGroups: [{id: '1', saisonen: [], spiele: [], spieleCup: [], nameShort: 'Nationale Ligen '}],
        }),
        created(){
            console.error ("created", );
            this.isLoading = true;
            this.setLVgroups();
            this.sportJahr = JSON.parse(JSON.stringify( this.$store.state.local.sportJahr.current.value ));
            this.loadLiveSpiele();
        },
        methods: {
            setLVgroups(){
                this.lvLocal.forEach( (lv) => {
                    this.lvGroups.push({id: lv.id, saisonen: [], spiele: [], spieleCup: [], nameShort: lv.nameShort})
                });
            },
            async loadLiveSpiele(){
                this.landesverbaende = await this.loadDocList('landesverbaende', {
                    field: 'sportart', operator: '==', value: 'classic'
                });
                this.saisonen = await this.loadDocList('saisonen', {
                    field: 'sportJahr', operator: '==', value: this.sportJahr
                });
                this.setSpieleFromSaison();
            },
                setSpieleFromSaison(){
                    this.saisonen.forEach( (saison) => {
                        const saisonTemp = new Saison();
                        saisonTemp.setFromDataObject(saison);
                        const landesverband = this.landesverbaende.find(lv => lv.id === saisonTemp.lvId);
                        const liveGames = saisonTemp.getLiveGames(
                            landesverband.ligen[saisonTemp.ligaId].nameFull
                        );
                        if ( liveGames.length > 0 ) {
                            this.gameCount += liveGames.length;
                            const lv = this.lvGroups.find(lv => lv.id === saisonTemp.lvId);
                            lv.saisonen.push(saisonTemp);
                            if ( saison.isCup ) {
                                lv.spieleCup = lv.spieleCup.concat(liveGames)
                            } else {
                                lv.spiele = lv.spiele.concat(liveGames)
                            }
                        }
                    });
                    this.isLoading = false;
                },

            async reloadSpiele(){
                this.isLoading = true;
                this.clearSpiele();
                this.saisonen = await this.loadDocList('saisonen', {
                    field: 'sportJahr', operator: '==', value: this.sportJahr
                });
                this.setSpieleFromSaison();
            },
                clearSpiele(){
                    this.lvGroups.forEach( (lvGroup) => {
                        this.gameCount = 0;
                        lvGroup.saisonen = [];
                        lvGroup.spiele = [];
                        lvGroup.spieleCup = [];
                    });
                },

            loadDocList(collectionName, queryParameter) {
                return new Promise(resolve => {
                    db.collection(collectionName)
                        .where(queryParameter.field, queryParameter.operator, queryParameter.value)
                        .get()
                        .then((querySnapshot) => {
                            let list = [];
                            querySnapshot.forEach((doc) => {
                                let document = doc.data();
                                document.id = doc.id;
                                list.push(document);
                            });
                            resolve(list);
                        }).catch((error) => {
                        console.log("Error getting document:", error);
                        resolve(null);
                    });
                })
            },
            back(){
                window.history.back();
            },
        },
    }
</script>

<style scoped>

</style>